import { type VariablesOf } from '@graphql-typed-document-node/core'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useBrandAccountId } from './useBrandAccountId'

const document = graphql(`
  mutation DocumentReportEditPage_CreateDocumentReport(
    $brandAccountId: ID!
    $content: String!
    $title: String!
  ) {
    createDocument(
      brandAccountId: $brandAccountId
      content: $content
      title: $title
    ) {
      id
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useCreateDocumentReportMutation = (
  options: MutationOptions<string, Omit<Variables, 'brandAccountId'>> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (variables) => {
      const result = await graphQLRequest({
        document,
        variables: { brandAccountId, ...variables },
      })

      const documentReportId = result.createDocument?.id
      if (!exists(documentReportId)) {
        throw new Error(t('creation_failed'))
      }

      return documentReportId
    },
    ...options,
  })
}
